import { useState, useRef, useCallback } from 'react';

// Extraído de `ComponentTaskHoy.jsx` (02.1-b6-taskhoy-orchestrator.md, paso C3) -- drag & drop
// HTML5 del tablero Kanban (mover una tarjeta a otra columna = cambio de stage), con auto-scroll
// horizontal cuando el cursor se acerca al borde del panel.
export function useTaskKanbanDrag({ tasks, getTaskPermissions, handleStageChange }) {
    const [draggedKanbanTaskId, setDraggedKanbanTaskId] = useState(null);
    const kanbanScrollRef = useRef(null);
    const kanbanDragStateRef = useRef({ isDragging: false, clientX: 0 });

    // HTML5 Kanban Board Drag & Drop Handlers
    const startKanbanAutoScroll = useCallback(() => {
        const loop = () => {
            if (!kanbanDragStateRef.current.isDragging) return;

            const panel = kanbanScrollRef.current;
            if (panel) {
                const rect = panel.getBoundingClientRect();
                const mouseX = kanbanDragStateRef.current.clientX;
                const threshold = 60; // wider edge margin for smooth dragging

                if (mouseX > 0) {
                    if (mouseX < rect.left + threshold) {
                        panel.scrollLeft -= 12;
                    } else if (mouseX > rect.right - threshold) {
                        panel.scrollLeft += 12;
                    }
                }
            }
            requestAnimationFrame(loop);
        };
        requestAnimationFrame(loop);
    }, []);

    const handleKanbanDragStart = (e, id) => {
        const task = tasks.find(t => t.id === id);
        if (task && getTaskPermissions(task.space_id)?.task_edit === false) {
            e.preventDefault();
            return;
        }
        setDraggedKanbanTaskId(id);
        e.dataTransfer.setData("text/plain", id);

        kanbanDragStateRef.current.isDragging = true;
        kanbanDragStateRef.current.clientX = e.clientX;
        startKanbanAutoScroll();
    };

    const handleKanbanDragOver = (e) => {
        e.preventDefault();
        kanbanDragStateRef.current.clientX = e.clientX;
    };

    const handleKanbanDragEnd = () => {
        kanbanDragStateRef.current.isDragging = false;
        setDraggedKanbanTaskId(null);
    };

    const handleKanbanDrop = (e, newStage) => {
        e.preventDefault();
        kanbanDragStateRef.current.isDragging = false;
        const taskId = e.dataTransfer.getData("text/plain") || draggedKanbanTaskId;
        if (taskId) {
            handleStageChange(taskId, newStage);
        }
        setDraggedKanbanTaskId(null);
    };

    return {
        kanbanScrollRef,
        handleKanbanDragStart, handleKanbanDragOver, handleKanbanDragEnd, handleKanbanDrop,
    };
}
